import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'scheduling';

export default {
  async search(params) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.get(url, { params });
  },
  async create(data) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, data);
  },
  async update(appointmentId, data) {
    const url = mountUrl(`/${BASE_PATH}/${appointmentId}`);
    return api.patch(url, data);
  },
  async markPresence(appointmentId, presence) {
    const url = mountUrl(`/web/${BASE_PATH}/${appointmentId}/presence`);
    return api.patch(url, { presence });
  },
};
